import React from "react";

import {blueColor, radioCircleGrey, sidebarColor, whiteColorHover} from "../../assets/jss/main";

export default function RadioButtonIcon({ checked }){
    return (
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fontSize="20px"
        >
            {!checked && (
                <circle
                    cx="50%"
                    cy="50%"
                    r="11px"
                    stroke={radioCircleGrey}
                    fill="none"
                />
            )}

            {checked && (
                <>
                    <circle
                        cx="50%"
                        cy="50%"
                        r="11px"
                        stroke="none"
                        fill={blueColor}
                    />
                    <circle
                        cx="50%"
                        cy="50%"
                        r="6px"
                        stroke="none"
                        fill={sidebarColor}
                    />
                </>
            )}
        </svg>
    )
}
